module.exports = __webpack_public_path__ + "img/pi-1-3-1.0ecb04de.jpg";